'use client'

import * as React from 'react'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useDeleteEmailTemplate } from '@/lib/api/emailTemplates'
import { useStoreNavigate } from '@/hooks/use-app-navigate'
import { useTranslation } from 'react-i18next'

interface DeleteEmailTemplateModalProps {
	templateId: string | undefined
	onClose: () => void
	onSuccess: () => void
}

export function DeleteEmailTemplateModal({ templateId, onClose, onSuccess }: DeleteEmailTemplateModalProps) {
	const { t } = useTranslation('emails')
	const { id: storeId } = useStoreNavigate()
	const deleteMutation = useDeleteEmailTemplate()

	const handleDelete = React.useCallback(async () => {
		if (!templateId || !storeId) return

		try {
			await deleteMutation.mutateAsync({ id: templateId, storeId })
			onSuccess()
			onClose()
		} catch (error) {
			console.error('Failed to delete email template:', error)
		}
	}, [templateId, storeId, deleteMutation, onSuccess, onClose])

	return (
		<AlertDialog open={!!templateId} onOpenChange={(open) => !open && onClose()}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t('delete.title')}</AlertDialogTitle>
					<AlertDialogDescription>
						{t('delete.description')}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{t('delete.cancel')}</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
						{t('delete.confirm')}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}

